import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCliente } from "../context/ClienteContext";

const ListagemDisciplinas = () => {
  const [disciplinas, setDisciplinas] = useState([]);
  const [codigoFiltro, setCodigoFiltro] = useState("");
  const [nomeFiltro, setNomeFiltro] = useState("");
  const navigate = useNavigate();
  const { parametros } = useCliente();
  const tipoUsuario = localStorage.getItem("tipo");
  const professorId = localStorage.getItem("user_id");


  useEffect(() => {
    buscarDisciplinas();
  }, []);

  const buscarDisciplinas = async () => {
    try {
      let response;
  
      if (tipoUsuario === "professor") {
        response = await fetch(`http://localhost:5000/api/disciplinas/professor/${professorId}`);
      } else {
        const clienteId = localStorage.getItem("cliente_id");
        if (!clienteId) {
          console.error("Cliente ID não encontrado no localStorage.");
          setDisciplinas([]);
          return;
        }
        response = await fetch(`http://localhost:5000/api/disciplinas?cliente_id=${clienteId}`);
      }
  
      const data = await response.json();
  
      if (Array.isArray(data)) {
        setDisciplinas(data);
      } else {
        console.error("Resposta inesperada ao buscar disciplinas:", data);
        setDisciplinas([]);
      }
    } catch (error) {
      console.error("Erro ao buscar disciplinas:", error);
      setDisciplinas([]);
    }
  };
  
  const disciplinasFiltradas = Array.isArray(disciplinas) ? disciplinas.filter((disciplina) => {
    return (
      (!codigoFiltro || disciplina.codigo.toLowerCase().includes(codigoFiltro.toLowerCase())) &&
      (!nomeFiltro || disciplina.nome.toLowerCase().includes(nomeFiltro.toLowerCase()))
    );
  }) : [];

  return (
    <div className="form-wrapper">
      <h2 className="form-title">
        {tipoUsuario === "professor" ? "Minhas Disciplinas" : "Disciplinas Cadastradas"}
      </h2>

      <div className="filtros-cursos">
        <div className="filtros-linha-1">
          <input
            type="text"
            placeholder="Filtrar por Código"
            value={codigoFiltro}
            onChange={(e) => setCodigoFiltro(e.target.value)}
            style={{ width: "100px" }}
          />
          <input
            type="text"
            placeholder="Filtrar por Nome"
            value={nomeFiltro}
            onChange={(e) => setNomeFiltro(e.target.value)}
          />
        </div>

        {tipoUsuario !== "professor" && (
         <div className="filtros-linha-2">
           <button className="btn btn-primary" onClick={() => navigate("/cadastro-disciplina")}>
             Adicionar Disciplina
           </button>
         </div>
       )}

      </div>

      <table className="tabela" style={{ fontSize: "0.75rem", marginTop: "10px" }}>
        <thead
          style={{
            backgroundColor: parametros?.cor_cabecalho || "#156082",
            color: "white"
          }}
        >
          <tr>
            <th style={{ width: "30%", textAlign: "left" }}>Código</th>
            <th style={{ width: "70%", textAlign: "left" }}>Nome</th>
          </tr>
        </thead>
        <tbody>
          {disciplinasFiltradas.length === 0 ? (
            <tr>
              <td colSpan="2">Nenhuma disciplina encontrada.</td>
            </tr>
          ) : (
            disciplinasFiltradas.map((disciplina) => (
              <tr key={disciplina.id}>
                <td>{disciplina.codigo}</td>
                <td>
                  <span
                    className="link-linha"
                    onClick={() => navigate(`/disciplina/${disciplina.id}`)}
                    style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                  >
                    {disciplina.nome}
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ListagemDisciplinas;
